function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 4.5H16.5v-.75a2.253 2.253 0 00-2.25-2.25h-4.5A2.253 2.253 0 007.5 3.75v.75H3.75a.75.75 0 000 1.5h.75v13.5A1.502 1.502 0 006 21h12a1.502 1.502 0 001.5-1.5V6h.75a.75.75 0 100-1.5zM10.5 15.75a.75.75 0 01-1.5 0v-6a.75.75 0 111.5 0v6zm4.5 0a.75.75 0 01-1.5 0v-6a.75.75 0 111.5 0v6zM15 4.5H9v-.75A.75.75 0 019.75 3h4.5a.75.75 0 01.75.75v.75z",
    fill: props.fill
  }));
}

export default SvgTrash;